<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~~/lib/tw-utils'

const props = defineProps<{
  defaultValue?: string | number
  class?: HTMLAttributes['class']
  internal?: boolean
}>()

const modelValue = defineModel<string | number>('modelValue', { default: '' })
const inputRef = ref<HTMLInputElement | null>(null)

defineExpose({ inputRef })
</script>

<template>
  <input
    ref="inputRef"
    v-model="modelValue"
    :class="
      cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible_ring-offset-background file_border-0 file_bg-transparent file_text-sm file_font-medium placeholder_text-muted-foreground focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50',
        props.internal ? 'border-internal focus-visible_border-internal' : 'focus-visible_ring-ring',
        props.class,
      )
    "
  />
</template>

<style scoped>
input::placeholder {
  font-style: normal;
}
</style>
